<h1 mat-dialog-title>
  <span> {{ data["title"] }} </span>
</h1>
<mat-dialog-content>
  <p [innerHtml]="data['message']"></p>
</mat-dialog-content>
<mat-dialog-actions>
  <button (click)="onNoClick()" mat-button>انصراف</button>
  <button [mat-dialog-close]="true" cdkFocusInitial mat-button>تایید</button>
</mat-dialog-actions>
